import { X } from 'lucide-react';
import { orDash } from '../../../../utils/schema-parse';
import { formatFullDate } from '../../../../utils/format-date';
import type { RelatorioVisitaCabecalho } from '../../schemas/payload.schema';

type Ndvi = NonNullable<RelatorioVisitaCabecalho['ndvi']>;

interface NdviModalProps {
  ndvi: Ndvi;
  open: boolean;
  onClose: () => void;
}

const NdviModal = ({ ndvi, open, onClose }: NdviModalProps) => {
  if (!open) return null;

  const legenda = ndvi.legenda ?? [];
  const dataLabel = ndvi.data ? formatFullDate(ndvi.data) : null;

  return (
    <div
      role="presentation"
      className="rv-ndvi-modal-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Imagem NDVI"
        className="rv-ndvi-modal-dialog"
      >
        <button
          type="button"
          aria-label="Fechar"
          className="rv-ndvi-modal-close"
          onClick={onClose}
        >
          <X size={18} />
        </button>

        <div className="rv-ndvi-modal-body">
          <div className="rv-ndvi-modal-main">
            {dataLabel && dataLabel !== '-' ? (
              <span className="rv-ndvi-modal-date">{dataLabel}</span>
            ) : null}

            <div className="rv-ndvi-modal-canvas">
              {ndvi.imagem ? (
                <img
                  alt="NDVI"
                  className="rv-ndvi-modal-image"
                  src={ndvi.imagem}
                />
              ) : null}
            </div>
          </div>

          <aside className="rv-ndvi-modal-side">
            <h2 className="rv-ndvi-modal-title">Legenda NDVI</h2>

            {legenda.length > 0 ? (
              <div className="rv-ndvi-modal-legend">
                {legenda.map((item) => (
                  <div
                    key={item.ordem ?? item.texto}
                    className="rv-ndvi-modal-legend-item"
                  >
                    <span
                      className="rv-ndvi-modal-swatch"
                      style={{
                        background: item.cor ?? 'rgb(var(--color-aqila-muted))',
                      }}
                    />
                    {orDash(item.texto)}
                  </div>
                ))}
              </div>
            ) : (
              <p className="rv-ndvi-modal-empty">Sem legenda disponível.</p>
            )}
          </aside>
        </div>
      </div>
    </div>
  );
};

export default NdviModal;
